import axios from "axios";
import { queryParams } from "../../../utils/queryParams";

const urn = "settings/organization_settings";

const users = axios.create({
  baseURL: queryParams.apiVersion + urn + "/users"
});

const settings = axios.create({
  baseURL: queryParams.apiVersion + urn + "/user_settings/settings"
});

export const usersApi = {
  getUsers(params) {
    return users.post("/get_users", params);
  },
  addUser(params) {
    return users.post("", params);
  },
  updateUser(id, params) {
    return users.put(`/${id}`, params);
  },
  getUserInfo(params) {
    return users.get("/get_users_info", params);
  },
  setUserAsCorporate(params) {
    return users.put("/set_corporate", params);
  },
  sendResetPasswordInstructions(params) {
    return users.post("/send_reset_password_instructions", params);
  },
  sendWelcomeEmail(params) {
    return users.post("/send_welcome_email", params);
  },
  sendFitlabMonthlyEmail(params) {
    return users.post("/send_fitlab_monthly_email", params);
  },
  removeUser(params) {
    return users.delete("/destroy_user", params);
  },
  duplicateUser(params) {
    return users.post("/duplicate_user", params);
  },
  mirrorUser(params) {
    return users.post("/mirror_user", params);
  },
  resetPassword(params) {
    return users.post("/reset_password", params);
  },
  addUserPermissionsAsCustomRole(params) {
    return users.post("/create_role", params);
  },
  loginAs(params) {
    return users.post("/login_as", params);
  }
};

export const settingsApi = {
  getSettings(params) {
    return settings.get("", params);
  },
  getUsersToMirror(params) {
    return settings.get("/get_mirror_users", params);
  },
  getActions(params) {
    return settings.get("/get_actions_list", params);
  }
};
